import throttle from 'lodash/throttle'

export const mq = {
  xxxs: `0`,
  xxs: `200`,
  xs: `320`,
  s: `400`,
  sl: `480`,
  sl2: `580`,
  m: `768`,
  ml: `992`,
  l: `1100`,
  xl: `1200`,
  xxl: `1300`,
  xxxl: `1400`,
  xxxxl: `1500`,
  xxxxxl: `1600`,
  xxxxxxl: `1700`
}

export const bp = [
  1700, 1600, 1500, 1400, 1300, 1200, 1100, 992, 768, 580, 480, 400, 320, 200, 0
]

export const MQ = (min, max) => {
  if (!min && !max) {
    return ``
  } else if (min && !max) {
    return `only screen and (min-width: ${min}px)`
  } else if (!min && max) {
    return `only screen and (max-width: ${max - 1}px)`
  } else {
    return `only screen and (min-width: ${min}px) and (max-width: ${max - 1}px)`
  }
}

export const mqBuilder = () => {
  const cbList = {}
  const runQueries = () => {
    Object.keys(cbList).forEach((mq) => {
      if (typeof cbList[mq] !== `object`) return
      const matches = window.matchMedia(mq).matches
      if (matches && !cbList[mq].isActive) {
        cbList[mq].cb()
      }
      cbList[mq].isActive = matches
    })
  }
  const runQueriesThrottle = throttle(runQueries, 100)

  const onResizeList = {}
  return {
    mount() {
      window.addEventListener(`resize`, runQueriesThrottle)
    },
    unMount() {
      window.removeEventListener(`resize`, runQueriesThrottle)
    },
    subscribeOnResize(cb) {
      onResizeList[cb] = throttle(cb)
      window.addEventListener(`resize`, onResizeList[cb])
    },
    unsubscribeOnResize(cb) {
      window.removeEventListener(`resize`, onResizeList[cb])
      delete onResizeList[cb]
    },
    subscribe(bp, cb = () => {}) {
      if (typeof bp !== `string` || typeof cb !== `function`) return
      cbList[bp] = {cb, bp, isActive: false}
    },
    unsubscribe(bp) {
      if (typeof bp !== `string`) return
      delete cbList[bp]
    },
    matches(bp) {
      return window.matchMedia(bp).matches
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/responsiveUtils.js